export default "__VITE_ASSET__DxvCmWb5__"